var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex justify-center align-center flex-column"},[_c('v-progress-circular',{staticClass:"ma-5",attrs:{"indeterminate":true}}),_c('div',{staticClass:"text-center"},[_vm._v(" Thanks for subscribing! Give us a couple seconds to process your subscription. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }